<template>
  <div class="background-main-container">
    <div class="background" :class="{'background--active' : IsShown}">
      <div class="background__tile" :style="{backgroundColor : Color }" v-for="n in 5" :key="n"></div>
    </div>
    <div class="background-content-container">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data: function () {
    return {};
  },
  props: ["Color", "IsShown"],
  methods: {},
};
</script>

<style>
.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 0%;
  transition: height 0s 0.8s ease;
  z-index: 9999998;
  transform: rotate(180deg);
}

.background-main-container {
  height: 100%;
}

.background .background__tile {
  position: absolute;
  left: 0;
  width: 20%;
  height: 0;
  background-color: #007ae5;
  background-repeat: no-repeat;
  background-attachment: fixed;
  /* background-image: linear-gradient(#840a1f, #240b36); */
  background-image: linear-gradient(#7f424d, #240b36);
  /* background-image: linear-gradient(#39638e, #170723); */

  transition: height 0.7s ease;
}
.background .background__tile:nth-child(0) {
  left: calc(-1 * 20%);
  transition-delay: -0.1s;
}
.background .background__tile:nth-child(1) {
  left: calc(0 * 20%);
  transition-delay: 0s;
}
.background .background__tile:nth-child(2) {
  left: calc(1 * 20%);
  transition-delay: 0.1s;
}
.background .background__tile:nth-child(3) {
  left: calc(2 * 20%);
  transition-delay: 0.2s;
}
.background .background__tile:nth-child(4) {
  left: calc(3 * 20%);
  transition-delay: 0.3s;
}
.background .background__tile:nth-child(5) {
  left: calc(4 * 20%);
  transition-delay: 0.4s;
}
.background--active {
  height: 100%;
  transition-delay: 0s;
}
.background--active .loader__icon {
  opacity: 1;
  transition: opacity 0.5s 1.4s ease;
}
.background--active .background__tile {
  height: 100%;
}
.background--active .background__tile:nth-child(0) {
  transition-delay: -0.2s;
}
.background--active .background__tile:nth-child(1) {
  transition-delay: 0s;
}
.background--active .background__tile:nth-child(2) {
  transition-delay: 0.2s;
}
.background--active .background__tile:nth-child(3) {
  transition-delay: 0.4s;
}
.background--active .background__tile:nth-child(4) {
  transition-delay: 0.6s;
}
.background--active .background__tile:nth-child(5) {
  transition-delay: 0.8s;
}

.background-content-container {
  position: relative;
  z-index: 9999999;
  height: 100%;
}
</style>